import React from "react";
import SectionContent from "./common_feature_content";
import SectionFeatureBox from "./common_feature_box";
import Br from "../img_query/plan_br";
import ShopPic from "../img_query/plan_shoppic";
import Statement from "../img_query/plan_statement";
import Apply1 from "../img_query/plan_apply1";
import Apply2 from "../img_query/plan_apply2";
import Apply3 from "../img_query/plan_apply3";
import Apply4 from "../img_query/plan_apply4";
import DetailButton from "./common_button_details";
import { FormattedMessage } from "gatsby-plugin-intl";

function Common_application() {

    return (
        <div>
          <SectionContent
            featureTitle="plan.apply.title"
            featureDescription="plan.apply.description"
            featureScheme=""
          />
          <div className="flex flex-col p-2 md:p-4 py-10 justify-center text-center max-w-6xl mx-auto">
            <div>
              <a
                className="mx-auto lg:mx-0 bg-teal-300 text-gray-900 text-lg lg:text-xl font-bold rounded-full py-2 px-2 md:px-8"
                role="button"
              >
                <FormattedMessage id="plan.apply.procedure" defaultMessage="簡易申請程序" />
              </a>
            </div>
            <div className="flex flex-wrap flex-row p-4 justify-center text-center max-w-6xl mx-auto">
              <div className="flex flex-col flex-shrink w-full md:w-1/2 lg:w-1/4 p-6">
                <SectionFeatureBox
                  featureImage={<Apply1 alt="Apply requirement" />}
                  featureName="plan.apply.form"
                  featureTC=" "
                  bgColor="bg-white"
                />
              </div>
              <div className="flex flex-col flex-shrink w-full md:w-1/2 lg:w-1/4 p-6">
                <SectionFeatureBox
                  featureImage={<Apply2 alt="Apply requirement" />}
                  featureName="plan.apply.submit"
                  featureTC=" "
                  bgColor="bg-white"
                />
              </div>
              <div className="flex flex-col flex-shrink w-full md:w-1/2 lg:w-1/4 p-6">
                <SectionFeatureBox
                  featureImage={<Apply3 alt="Apply requirement" />}
                  featureName="eKYC"
                  featureTC=" "
                  bgColor="bg-white"
                />
              </div>
              <div className="flex flex-col flex-shrink w-full md:w-1/2 lg:w-1/4 p-6">
                <SectionFeatureBox
                  featureImage={<Apply4 alt="Apply requirement" />}
                  featureName="plan.apply.exp"
                  featureTC=" "
                  bgColor="bg-white"
                />
              </div>
            </div>

            <div className="flex flex-col p-2 md:p-4 justify-center text-center max-w-6xl mx-auto">
              <div>
                <a
                  className="mx-auto lg:mx-0 bg-teal-300 text-gray-900 text-lg lg:text-xl font-bold rounded-full py-2 px-2 md:px-8"
                  role="button"
                >
                  <FormattedMessage id="plan.apply.doc" defaultMessage="準備所需文件" />
                </a>
              </div>
              <div className="flex flex-wrap flex-row p-4 justify-center text-center max-w-6xl mx-auto">
                <div className="flex flex-col flex-shrink w-full md:w-1/2 lg:w-1/4 p-6">
                  <SectionFeatureBox
                    featureImage={<Br Alt="Br" />}
                    featureName="plan.apply.br"
                    featureTC=" "
                    bgColor="bg-white"
                  />
                </div>
                <div className="flex flex-col flex-shrink w-full md:w-1/2 lg:w-1/4 p-6">
                  <SectionFeatureBox
                    featureImage={<Statement alt="Statement" />}
                    featureName="plan.apply.statement"
                    featureTC=" "
                    bgColor="bg-white"
                  /> 
                </div>
                <div className="flex flex-col flex-shrink w-full md:w-1/2 lg:w-1/4 p-6">
                  <SectionFeatureBox
                    featureImage={<ShopPic Alt="Picture of shop" />}
                    featureName="plan.apply.photo"
                    featureTC=" "
                    bgColor="bg-white"
                  />
                </div>
              </div>
              <div className="text-xs md:text-base">
                <p><FormattedMessage id="plan.apply.tc" defaultMessage="*不同的計劃或需另外遞交附加文件，詳情請向客戶服務員查詢" /></p>
              </div>
              <div className="flex justify-center p-4 py-10">
                <div className="w-full md:w-1/3 px-6">
                  <DetailButton
                        buttonLink="/about#contact"
                        buttonID="btnOtherApply"
                        buttonDisplayName="plan.apply.details"
                        buttonBgColor="gradient"
                        buttonTextColor="text-white"
                        buttonHoverBgColor=""
                        buttonHoverTextColor="hover:text-yellow-300"
                    />
                </div>
              </div>
            </div>
          </div>
        </div>
    );
}

export default Common_application;